<template>
  <div class="com" :class="isMobile() ? 'mobile' : 'desktop'">
    <div class="box" v-loading="loadingDocs" :style="{ height: (contenitoreHeight) + 'px' }">
      <docs-header-mobile :route="'DocumentiPers'" :showFilter="showFilter"
        :title="$i18n.t(this.$route.name + '.label')" @changeMonth="changeMonth" class="top-block"
        :style="{ height: heightHeader + 'px' }" v-if="isMobile()"></docs-header-mobile>
      <docs-header :route="'DocumentiPers'" :showFilter="showFilter" :title="$i18n.t(this.$route.name + '.label')"
        @changeMonth="changeMonth" class="top-block" :style="{ height: heightHeader + 'px' }"
        v-if="!isMobile()"></docs-header>
      <div class="box-documents" :style="{ height: (contenitoreHeight - 80) + 'px' }">
        <div class="gridDocs">
          <div class="row row-custom">
            <div v-for="(doc, index) in docs" :class="[isMobile() ? 'col-24' : 'col-8']" class="padding-2" :key="index">
              <grid-doc-Mobile v-if="isMobile()" :doc="doc" class="docs-body"
                :showInDashboard="showInDashboard"></grid-doc-Mobile>
              <grid-doc v-else :doc="doc" class="docs-body" :showInDashboard="showInDashboard"></grid-doc>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import DocsHeader from './DocsHeader.vue'
import DocsHeaderMobile from './DocsHeaderMobile.vue'
import GridDoc from './gridDoc.vue'
import GridDocMobile from './gridDocMobile.vue'
import moment from 'moment'
import { bus } from "../Bus";

export default {
  components: {
    DocsHeader,
    DocsHeaderMobile,
    GridDocMobile,
    GridDoc
  },
  name: 'Comunicazioni',
  props: ['contenitoreHeight', 'showInDashboard', 'objComunicazione'],
  i18n: {
    messages: {
      it_IT: {
        docs: {
          download: 'Leggi',
          pubblicazione: 'Pubblicato il: ',
          scadenza: 'Scade il:',
          btn: {
            annulla: 'Annulla',
            presaVisione: 'Presa Visione',
            leggi: 'Leggi',
            close: 'Chiudi'
          }
        }
      },
      fr_FR: {
        docs: {
          download: 'Lois',
          pubblicazione: 'Pubblicato il: ',
          scadenza: 'Scade il:',
          btn: {
            annulla: 'Annule',
            presaVisione: 'Presa Visione',
            leggi: 'Lire',
            close: 'Fermer'
          }
        }
      },
      es_ES: {
        docs: {
          download: 'Leyes',
          pubblicazione: 'Publicado el : ',
          scadenza: 'Caduca el:',
          btn: {
            annulla: 'Anular',
            presaVisione: 'Presa Visione',
            leggi: 'Leer',
            close: 'Cierra'
          }
        }
      },
      de_DE: {
        docs: {
          download: 'Download',
          pubblicazione: 'Publicado el : ',
          scadenza: 'Caduca el:',
          btn: {
            annulla: 'Anular',
            presaVisione: 'Presa Visione',
            leggi: 'Lesen',
            close: 'Schließen'
          }
        }
      },
      en_GB: {
        docs: {
          download: 'Download',
          pubblicazione: 'Publicado el : ',
          scadenza: 'Caduca el:',
          btn: {
            annulla: 'Anular',
            presaVisione: 'Presa Visione',
            leggi: 'Read',
            close: 'Close'
          }
        }
      }
    }
  },
  data() {
    return {
      moment: moment,
      docs: [],
      loadingDocs: false,
      showFilter: this.$route.meta.showFilter,
      heightHeader: 80
    }
  },
  activated: function () {
  },
  mounted: function () {
    if (this.objComunicazione.codice !== undefined) {
      this.showFilter = this.showInDashboard === true ? false : this.objComunicazione.showFilter

      this.loadDocs(this.objComunicazione.mesi)
    }

  },
  methods: {
    loadDocs: function (month) {
      this.loadingDocs = true
      var obj = {
        params: {
          mesi: month
        }
      }
      this.$http.get('communication/' + this.$store.state.country + '/avvisi', obj).then(response => {
        if (response.body.rc === 0) {
          this.docs = response.body.data
          this.loadingDocs = false
          // sessionStorage.setItem('token', response.body.wsToken)
          // sessionStorage.setItem('token_download', response.body.wsTokenDownload)
          // this.$router.push({name: 'IndexPortale'})
        }
      }, response => {
        this.loadingDocs = false
      })
    },
    getNome: function (doc) {
      let nome = this.$i18n.t('documentType.' + doc.container + '.label')
      return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
    },
    changeMonth: function (month) {
      if (this.objComunicazione.codice !== undefined) {
        this.loadDocs(month)
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";


.com {
  height: 100%;
  padding: 10px;

  &.desktop {
    .box {
      overflow: auto;
      background-color: #f2f2f2;
      border-radius: 5px;

      .top-block {
        background-color: #f2f2f2;
        width: 100%;
        z-index: 1;
      }

      .box-documents {
        overflow: auto;

        .gridDocs {
          overflow: auto;
          padding-left: 15px;
          padding-right: 15px;

          .padding-2 {
            padding-left: 3px;
            padding-right: 3px;
          }
        }

        .gridMessage {
          overflow: auto;
          padding-left: 15px;
          padding-right: 15px;

          .msgDetail {
            .padding-2 {
              padding-left: 3px;
              padding-right: 3px;
            }

            .el-card {
              width: 100%;
              height: 115px;
              float: left;
              margin-bottom: 10px;
              border-radius: 0px;
              padding: 5px 10px !important;

              // cursor: pointer;
              .el-card__body {
                padding: 0;
                height: 100%;

                .card-testata {
                  width: 100%;
                  height: 30px;
                  padding: 0 !important;
                  display: flex;
                  justify-content: space-between;

                  .titolo {
                    width: 80%;
                    .set-font(@family: 'os-semibold', @color: @greenRiva, @size: 14px);
                    text-align: left;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }

                  .priorita {
                    margin-left: 10px;

                    .fa-icon {
                      color: red;
                    }
                  }

                  .allegati {
                    .fa-icon {
                      color: @greenRiva;
                    }
                  }

                  .ricevuto {
                    .set-font(@color: @greenRiva, @size: 10px);
                    font-style: italic;
                    margin-top: 3px;
                  }

                  .presa-vis {
                    .fa-icon {
                      color: @rossoRiva;
                    }
                  }

                  .presa-vis-yes {
                    .fa-icon {
                      color: @greenTick;
                    }
                  }
                }

                .testo {
                  height: 50px;
                  padding: 0 5px !important;
                  .set-font(@size: 12px; @color: @textTable);
                  text-align: left;
                  word-break: break-word;
                }

                .footer {
                  display: inline-block;

                  //position: absolute;
                  //bottom: 6px;
                  //left: 0;
                  //padding: 0 10px !important;
                  .data {
                    .set-font(@size: 10px);
                    float: left;
                    line-height: 20px;
                    font-style: italic;
                    padding-top: 2px;
                  }

                  .el-button {
                    float: right;
                    height: 23px;
                    line-height: 20px;
                    padding: 0 6px;
                    border-color: @oroRiva !important;
                    background-color: @oroRiva !important;
                  }

                  .skip {
                    float: right;
                    margin-right: 2px;
                    text-align: right;

                    .el-badge {
                      .fa-icon {
                        color: @oroRiva;
                      }

                      .el-badge__content {
                        border: none;
                        background-color: transparent;
                        color: #CBB385;
                        right: 10px;
                      }
                    }
                  }
                }
              }
            }

            & .selected {
              background-color: @hoverTbl;
            }

            & .important {
              border-left: 3px solid @greenRiva;

              .testo {
                word-break: break-word;
                .set-font(@color: @textTable, @size: 12px, @family: 'os-bold') !important;
              }

              .footer {
                .data {
                  .set-font(@color: @greenRiva, @size: 10px, @family: 'os-bold') !important;
                  font-style: normal;
                }
              }
            }
          }
        }
      }
    }
  }

  &.mobile {
    .box {
      .box-documents {
        overflow: auto;
        padding-bottom: 60px;

        .gridDocs {
          overflow: auto;

          //padding-left: 15px;
          //padding-right: 15px;
          .padding-2 {
            padding-left: 3px;
            padding-right: 3px;
          }
        }

        .gridMessage {
          overflow: auto;
          padding-left: 0px;
          padding-right: 0px;

          .padding-2 {
            padding-left: 3px;
            padding-right: 3px;
          }

          .el-card {
            width: 100%;
            height: 115px;
            float: left;
            margin-bottom: 10px;
            border-radius: 0px;
            padding: 5px 10px !important;
            cursor: pointer;

            .el-card__body {
              padding: 0;
              height: 100%;

              .card-testata {
                width: 100%;
                height: 30px;
                padding: 0 !important;
                display: flex;
                justify-content: space-between;

                .titolo {
                  width: 80%;
                  .set-font(@family: 'os-semibold', @color: @greenRiva, @size: 14px);
                  text-align: left;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

                .priorita {
                  margin-left: 10px;

                  .fa-icon {
                    color: red;
                  }
                }

                .allegati {
                  .fa-icon {
                    color: @greenRiva;
                  }
                }

                .ricevuto {
                  .set-font(@color: @greenRiva, @size: 10px);
                  font-style: italic;
                  margin-top: 3px;
                }

                .presa-vis {
                  .fa-icon {
                    color: @rossoRiva;
                  }
                }

                .presa-vis-yes {
                  .fa-icon {
                    color: @greenTick;
                  }
                }
              }

              .testo {
                height: 50px;
                padding: 0 5px !important;
                .set-font(@size: 12px; @color: @textTable);
                text-align: left;
                word-break: break-word;
              }

              .footer {
                display: inline-block;

                //position: absolute;
                //bottom: 6px;
                //left: 0;
                //padding: 0 10px !important;
                .data {
                  .set-font(@size: 10px);
                  float: left;
                  line-height: 20px;
                  font-style: italic;
                  padding-top: 2px;
                }

                .el-button {
                  float: right;
                  height: 23px;
                  line-height: 20px;
                  padding: 0 6px;
                  border-color: @oroRiva !important;
                  background-color: @oroRiva !important;
                }

                .skip {
                  float: right;
                  margin-right: 2px;
                  text-align: right;

                  .el-badge {
                    .fa-icon {
                      color: @oroRiva;
                    }

                    .el-badge__content {
                      border: none;
                      background-color: transparent;
                      color: #CBB385;
                      right: 10px;
                    }
                  }
                }
              }
            }
          }

          & .selected {
            background-color: @hoverTbl;
          }

          & .important {
            border-left: 3px solid @greenRiva;

            .testo {
              word-break: break-word;
              .set-font(@color: @textTable, @size: 12px, @family: 'os-bold') !important;
            }

            .footer {
              .data {
                .set-font(@color: @greenRiva, @size: 10px, @family: 'os-bold') !important;
                font-style: normal;
              }
            }
          }
        }
      }
    }
  }
}

.modal-message-mobile {
  .custom-dialog {
    height: 80% !important;
    width: 98% !important;
    margin-top: 20% !important;
  }

  .el-dialog {
    .el-dialog__body {
      height: -moz-calc(100% - 200px);
      height: -webkit-calc(100% - 200px);
      height: calc(100% - 200px);
      overflow: auto;
      padding-left: 0px;
      padding-right: 0px;

      .data {
        width: 100%;
        text-align: right;
        margin-top: 10px;
        .set-font(@size: 12px, @color: @textTable);
        font-style: italic;
        padding: 0 4px !important;
      }

      .priorita {
        margin-top: 15px;
        text-align: left;

        .prior-label {
          .set-font(@color: @textTable, @size: 14px, @family: 'os-semibold');
        }

        .prior-value {
          margin-left: 2px;
          .set-font(@color: red, @size: 14px, @family: 'os-semibold');
        }

        .prior-icon {
          .fa-icon {
            color: red;
            margin-top: -4px;
            margin-left: 2px;
          }
        }
      }

      .testo {
        margin-top: 20px;
        .set-font(@color: @textTable, @size: 13px);
        text-align: justify;
        height: auto;
        overflow: auto;
        padding-right: 5px !important;
        word-break: break-word;
      }

      .allegati {
        min-height: 30px;
        max-height: 120px;
        overflow: auto;
        margin-top: 30px;
        margin-bottom: 20px;

        .allegato {
          display: inline-block;

          .icona {
            width: 10%;
            float: left;
            padding-top: 2px;
          }

          .titolo-allegato {
            width: 85%;
            float: left;
            .set-font(@color: @greenRiva, @size: 13px);
            text-align: left;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .allegato:hover {
          cursor: pointer;
        }
      }
    }

    .el-dialog__footer {
      padding: 10px 0 0;
      height: 160px;

      .footer {
        height: 45px;
        width: 100%;
        padding: 0 !important;

        .scade {
          padding: 10px 0 0 15px;
          .set-font(@color: @textTable, @size: 12px);
          font-style: italic;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Documenti/Modulistica.vue